import { createFileRoute } from '@tanstack/react-router';
import { ConfiguracaoUsuarioPage } from '@/features/configuracao-usuario/page/ConfiguracaoUsuarioPage';

export const Route = createFileRoute('/a/configuracao/usuario')({
    component: ConfiguracaoUsuarioPage,
});
